import { ref, watch, onMounted } from "@vue/composition-api";
import { DefaultConfigs, IPadProConfigs } from "../../services/DefaultConfigs";

const LABEL_SHIFT = -7;
const MAGIC_SHIFT = 8;

export default function useLineChartLabels(lineChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef) {
  const labels = ref([]);

  const font = `${isIPadProRef?.value ? IPadProConfigs.LineChart.lineLabel.fontSize : DefaultConfigs.LineChart.lineLabel.fontSize}px ${DefaultConfigs.LineChart.lineLabel.fontFamily}`;

  const updateLabels = () => {
    if (!xRef?.value || !yRef?.value) {
      labels.value = [];
      return;
    }

    const halfXBandwidth = xBandwidthRef.value / 2;

    const newLabels = lineChartDataSetRef.value.map((d, i) => {
      if (!d.label.sup) {
        return;
      }

      const x = xRef.value(d.x) + halfXBandwidth + MAGIC_SHIFT;
      const y = yRef.value(d.y) + LABEL_SHIFT;

      return {
        id: `label-${d.x}-${i}`,
        x,
        y,
        font,
        set: d.setName,
        text: d.label.sup,
      };
    });

    labels.value = newLabels;
  };

  watch([lineChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef, isIPadProRef], updateLabels);

  onMounted(updateLabels);

  return { labels };
}
